import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'trustee',
    label: 'Trustee',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'settlor',
    label: 'Settlor',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'beneficiary',
    label: 'Beneficiary',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const trusteeSettlorBeneficiaryForm = {
  name: FormNames.TITLE_HOLDER_GENERAL,
  label: 'Trustee/ Settlor/ Beneficiary',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
